<template>
  <div class="user-message">
    <div class="titles-right">我的需求</div>
    <!-- 处理中和已反馈 -->
    <div>
      <div class="flex f-jcenter">
        <div
          class="ma-r-20 c-pointer pa-b-5"
          :class="queryList.status == 1 ? 'tab-active' : ''"
          @click="
            queryList.status = 1;
            loadDataList();
          "
        >
          处理中
        </div>
        <div
          class="ma-l-20 c-pointer pa-b-5"
          :class="queryList.status == 2 ? 'tab-active' : ''"
          @click="
            queryList.status = 2;
            loadDataList();
          "
        >
          已反馈
        </div>
      </div>
      <!-- 反馈列表 -->
      <div
        class="shadow pa-b-10 pa-r-10 ma-t-20 ma-r-20"
        v-for="(item, index) in commentList"
        :key="index"
      >
        <div class="fon-18 flex f-center">
          <img :src="item.HeadImage" alt="" srcset="" class="head-img" />
          {{ item.InsertTime }}
        </div>
        <div class="comment-box">
          {{ item.Content }}
          <div
            class="pa-10 c-000 b-f7f7f7 ma-t-10"
            v-if="item.DisposeRemark != ''"
          >
            <div>
              {{ item.DisposeTime }}
            </div>
            <span class="font-bold">需求反馈：</span>{{ item.DisposeRemark }}
          </div>
        </div>
      </div>
      <div class="t-center ma-t-20">
        <el-pagination
          @current-change="handleCurrentChange"
          :hide-on-single-page="true"
          :current-page.sync="queryList.pageIndex"
          :page-size="queryList.pageSize"
          layout="prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>

      <div v-if="commentList.length==0" class="pa-t-100">
        <Empty></Empty>
      </div>

    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { getMytDatumList } from "../api";
export default {
  name: "Papers",
  props: {},
  data() {
    return {
      commentList: [],
      queryList: {
        pageIndex: 1,
        pageSize: 10,
        status: 1,
      },
      totals: 0, //一个分类下的总条数
    };
  },
  created() {
    this.loadDataList();
  },
  mounted() {},
  // 其他页面进来时更新初始数据
  activated() {},
  methods: {
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.queryList.pageIndex = e;
      this.loadDataList();
    },
    // 分享
    share(path, id) {
      console.log(path);
      console.log(id);
      let spath = path;
      let ids = id;
      let token = localStorage.getItem("AccessToken");
      let paths = `${spath}/shares.html?id=${ids}&token=${token}`;
      // console.log(paths)

      this.centerDialogVisible = true;
      this.$nextTick(() => {
        new QRCode(document.getElementById("qrCode"), {
          text: paths,
          width: 300,
          height: 300,
          colorDark: "#333333", //二维码颜色
          // colorLight: '#ffffff', //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      });
    },
    //分页查询
    loadDataList() {
      getMytDatumList(this.queryList).then((res) => {
        this.commentList = res.data.Data.List;
        this.totals = res.data.Data.TotalCount;
      });
    },
  },
};
</script>

 <style lang="scss" scoped>
.head-img {
  width: 50px;
  height: 50px;
  margin: 10px;
  border-radius: 50%;
}
.comment-box {
  margin-left: 70px;
  color: #999;
}
</style>
